import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const COLORS = ["#897DD9", "#F593CB", "#5DC2B7"];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        style={{
          backgroundColor: "#E0B8FF",
          padding: "6px 10px",
          borderRadius: 6,
          color: "#212121",
          fontSize: 12,
          boxShadow: "0 0 5px rgba(0,0,0,0.1)",
        }}
      >
        <div>
          <strong>{data.name}:</strong> {data.value}
        </div>
      </div>
    );
  }
  return null;
};

const SourcePieChart = ({ data, isFullscreen = false }) => {
  if (!data) return null;

  const pieData = [
    { name: "Sources", value: data.total_sources || 0 },
    { name: "Targets", value: data.total_targets || 0 },
    { name: "Transformations", value: data.total_transformations || 0 },
  ];

  // Original sizes are restored
  const outerRadius = isFullscreen ? 200 : 140;
  const chartHeight = isFullscreen ? "70vh" : "300px";
  const legendPosition = isFullscreen ? "center" : "center";

  return (
    <div style={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <div style={{
        width: "100%",
        height: chartHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              outerRadius={outerRadius}
              fill="#8884d8"
              dataKey="value"
              labelLine={false}
            >
              {pieData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              content={<CustomTooltip />}
              wrapperStyle={{ zIndex: 1000 }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Custom Legend */}
      <div
        className="custom-legend-flex mt-3 px-2"
        style={{
          display: "flex",
          justifyContent: legendPosition,
          width: "100%",
          flexWrap: "nowrap", // This is the key change to prevent wrapping
          gap: isFullscreen ? "20px" : "12px", // Use gap for spacing instead of margin
        }}
      >
        {pieData.map((entry, index) => (
          <div
            key={index}
            className="legend-item"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 6,
              // marginRight is removed, spacing is now handled by "gap"
            }}
          >
            <span
              className="legend-color-box"
              style={{
                width: isFullscreen ? 16 : 12,
                height: isFullscreen ? 16 : 12,
                backgroundColor: COLORS[index % COLORS.length],
                marginRight: 8,
                borderRadius: 2,
              }}
            />
            <span className="legend-label" style={{
              fontSize: isFullscreen ? 14 : 12
            }}>
              {entry.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SourcePieChart;